import { render } from "./RequestEdit.vue?vue&type=template&id=532114ca&ts=true"
import script from "./RequestEdit.vue?vue&type=script&lang=ts"
export * from "./RequestEdit.vue?vue&type=script&lang=ts"

import "./RequestEdit.vue?vue&type=style&index=0&id=532114ca&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__